import * as React from "react";
import { WSErrorContainer } from "./WSErrorContainer";

export function withWSErrorContainer<T>(Component: (props?: T) => JSX.Element) {
  return (props: T = {} as T) => (
    <WSErrorContainer>
      <Component {...props} />
    </WSErrorContainer>
  );
}
